// Shared constants for the Sale Pick List feature.

// ─── API endpoints ───────────────────────────────────────────────────────────
// LEGACY (`/pick-list/today`) backs `views/PickList/`; V2 (`/pick-list`) backs
// `views/SalePickList/`. Picked between by `SalePickListStore.useNewApi`.
export const PICK_LIST_ENDPOINTS = Object.freeze({
  LEGACY:  '/pick-list/today',
  V2:      '/pick-list',
  SUMMARY: '/pick-list/summary',
})

// SalePickList is v2 only. The legacy view owns its own store.
export const USE_NEW_PICK_LIST_API = true

// ─── group_by ────────────────────────────────────────────────────────────────
// Outer grouping axis on the page.

export const PICK_LIST_GROUP_BY = Object.freeze({
  LOCATION: 'location',
  ORDER:    'order',
})

export const PICK_LIST_GROUP_BY_VALUES = Object.values(PICK_LIST_GROUP_BY)

export const PICK_LIST_GROUP_BY_OPTIONS = [
  { value: PICK_LIST_GROUP_BY.LOCATION, label: 'By Location' },
  { value: PICK_LIST_GROUP_BY.ORDER,    label: 'By Order'    },
]

export const DEFAULT_PICK_LIST_GROUP_BY = PICK_LIST_GROUP_BY.LOCATION

// ─── sub_group ───────────────────────────────────────────────────────────────
// Optional secondary nesting axis. Ignored by the BE if it equals `group_by`.

export const PICK_LIST_SUB_GROUP = Object.freeze({
  LOCATION: 'location',
  ORDER:    'order',
  NONE:     'none',
})

export const PICK_LIST_SUB_GROUP_VALUES = Object.values(PICK_LIST_SUB_GROUP)

export const PICK_LIST_SUB_GROUP_OPTIONS = [
  { value: PICK_LIST_SUB_GROUP.NONE,     label: 'None'         },
  { value: PICK_LIST_SUB_GROUP.LOCATION, label: 'By Location'  },
  { value: PICK_LIST_SUB_GROUP.ORDER,    label: 'By Order'     },
]

export const DEFAULT_PICK_LIST_SUB_GROUP = PICK_LIST_SUB_GROUP.NONE

// ─── picked filter ───────────────────────────────────────────────────────────
// BE accepts string values, not booleans.

export const PICK_LIST_PICKED_FILTER = Object.freeze({
  ANY:    'any',
  TRUE:   'true',
  FALSE:  'false',
})

export const PICK_LIST_PICKED_FILTER_VALUES = Object.values(PICK_LIST_PICKED_FILTER)

export const PICK_LIST_PICKED_FILTER_OPTIONS = [
  { value: PICK_LIST_PICKED_FILTER.ANY,   label: 'Any'         },
  { value: PICK_LIST_PICKED_FILTER.FALSE, label: 'Not picked'  },
  { value: PICK_LIST_PICKED_FILTER.TRUE,  label: 'Picked'      },
]

export const DEFAULT_PICK_LIST_PICKED_FILTER = PICK_LIST_PICKED_FILTER.ANY

// ─── sort presets ────────────────────────────────────────────────────────────
// Pick list sorts CLIENT-SIDE per the contract — these values never reach the
// BE. Kept here so the toolbar dropdown and any URL-state validator share one
// list.

export const PICK_LIST_SORT_PRESETS = [
  { value: 'newest',         label: 'Newest'           },
  { value: 'oldest',         label: 'Oldest'           },
  { value: 'highest_value',  label: 'Highest value'    },
  { value: 'recently_picked', label: 'Recently picked' },
]

export const PICK_LIST_SORT_PRESET_VALUES = PICK_LIST_SORT_PRESETS.map(p => p.value)

export const DEFAULT_PICK_LIST_SORT_PRESET = 'newest'
